jQuery(document).ready(function () {
    // the file is loaded everywhere, but neaded only on the course page
    if (!jQuery(".course-page")[0] && !jQuery(".clp-section9__v-wrapper")[0]) {
        return;
    }

    //show bottom bar
    function handleBBar() {
        var bar = jQuery(".clp-bbar");
        if (!bar.length) return;

        function showBar() {
            var fromTop = jQuery(window).scrollTop();
            if (fromTop >= 70) {
                bar.addClass("visible");
                jQuery("html").addClass("clp-doc");
            } else {
                bar.removeClass("visible");
                jQuery("html").removeClass("clp-doc");
            }
        }

        jQuery(window).on("scroll", showBar);

        showBar();
    }

    handleBBar();

    // the course accordion
    jQuery(".clp-accordion__item div").on("click", function () {
        var isActive = jQuery(this).parent().hasClass("clp-accordion__item_active");

        if (isActive) {
            jQuery(".clp-accordion__sub").slideUp();
            jQuery(".clp-accordion__item").removeClass("clp-accordion__item_active");
        } else {
            jQuery(".clp-accordion__sub").slideUp();
            jQuery(".clp-accordion__item").removeClass("clp-accordion__item_active");

            jQuery(this).parent().find(".clp-accordion__sub").slideDown();
            jQuery(this).parent().addClass("clp-accordion__item_active");
        }
    });

    // the player
    var tag = document.createElement("script");

    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // get certified video
    var player1;

    // testimonials video 1
    var player2;

    // testimonials video 2
    var player3;

    // testimonials video 3
    var player4;

    var players = {};

    // The shopify theme is rewriting my onYouTubeIframeAPIReady function,
    // but it is triggering 'youTubeReady' event on the body, so Im using it
    jQuery("body").on("youTubeReady", function () {
        var hasControls = 0;
        var width = jQuery(window).outerWidth();
        if (width >= 700) {
            hasControls = 1;
        }

        setTimeout(function () {
            function handleSliderPlayers() {
                var currentPlayers = jQuery(".clp-section9__player");

                currentPlayers.each(function (index) {
                    var playerId = jQuery(this).attr("id");
                    var id = jQuery(this).data().video;

                    if (!playerId) return;

                    if (jQuery("#" + playerId).hasClass("live-video")) {
                        hasControls = 1;
                    }

                    players[playerId] = new YT.Player(playerId, {
                        videoId: id,
                        playerVars: {
                            rel: 0,
                            controls: hasControls,
                            modestbranding: 1,
                            showinfo: 0,
                            brand: 0,
                            auto: 0,
                        },
                        events: {
                            onReady: onPlayerReady,
                            onStateChange: stateChange,
                        },
                    });

                    if (jQuery("#" + playerId).hasClass("live-video")) {
                        setTimeout(() => {
                            players[playerId].mute();
                            players[playerId].playVideo();
                        }, 1000);
                    }
                });
            }
            handleSliderPlayers();

            player1 = new YT.Player("clp-player1", {
                videoId: "gUIqcW-NPTc",
                playerVars: {
                    rel: 0,
                    controls: hasControls,
                    modestbranding: 1,
                    showinfo: 0,
                    brand: 0,
                    auto: 0,
                },
                events: {
                    onReady: onPlayerReady,
                },
            });
        }, 1000);
    });

    var ready;

    function onPlayerReady(event) {
        ready = true;
    }

    function stateChange(event) {
        var el = jQuery(event.target.h).parent();
        if (event.data == 1) {
            el.addClass("active");
        } else {
            // el.removeClass("active");
        }
    }

    jQuery(".clp-section1__v-wrapper").on("click", function () {
        jQuery(this).addClass("clp-section1__v-wrapper_active");

        function checkReady() {
            if (ready && player1 && player1.playVideo) {
                player1.playVideo();
            } else {
                setTimeout(function () {
                    checkReady();
                }, 200);
            }
        }

        checkReady();
    });

    jQuery(".clp-section9__v-wrapper").on("click", function (e) {
        if (jQuery(this).hasClass("no-click")) {
            return;
        }
        var player = jQuery(this).find(".clp-section9__player").attr("id");
        players[player].playVideo();
    });

    //Dream team slider
    jQuery(".clp-section3__slider").slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        prevArrow: '<span class="clp-arrow clp-arrow_prev"></span>',
        nextArrow: '<span class="clp-arrow clp-arrow_next"></span>',
        autoplay: true,
        responsive: [
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    adaptiveHeight: true,
                    // centerMode: true,
                    // variableWidth: true,
                },
            },
        ],
    });

    // Hands on slider
    jQuery(".clp-hands-on__slider").slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        asNavFor: ".hands-on-dots",
        //         autoplay: true,
        arrows: false,
        dots: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    // hands on dots

    jQuery(".hands-on-dots").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: ".clp-hands-on__slider",
        dots: false,
        arrows: false,
        centerMode: true,
        focusOnSelect: true,
    });

    // Videos slider
    var videoSlider = jQuery(".clp-section9__slider");
    var handsOnSlider = jQuery(".hands-on__slider");

    jQuery(".sm-reviews .slick-slide").bind("touchstart", function () {});

    videoSlider.slick({
        infinite: true,
        prevArrow: '<span class="clp-arrow clp-arrow_prev"></span>',
        nextArrow: '<span class="clp-arrow clp-arrow_next"></span>',
        responsive: [
            {
                breakpoint: 650,
                settings: {
                    dots: true,
                    arrows: false,
                },
            },
        ],
    });

    videoSlider.on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
            // prevent clicking ( and starting the video ) while drag changing the slide
            jQuery(".clp-section9__v-wrapper").addClass("no-click");

            // stop the video of the current slider
            var player = jQuery(slick.$slides[currentSlide])
                .find(".clp-section9__player")
                .attr("id");

            if (!players[player]) return;
            players[player].stopVideo();
        }
    );

    videoSlider.on(
        "afterChange",
        function (event, slick, currentSlide, nextSlide) {
            jQuery(".clp-section9__v-wrapper").removeClass("no-click");
        }
    );

    handsOnSlider.slick({
        infinite: true,
        prevArrow: '<span class="clp-arrow clp-arrow_prev"></span>',
        nextArrow: '<span class="clp-arrow clp-arrow_next"></span>',
    });

    handsOnSlider.on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
            // prevent clicking ( and starting the video ) while drag changing the slide
            jQuery(".clp-section9__v-wrapper").addClass("no-click");

            // stop the video of the current slider
            var player = jQuery(slick.$slides[currentSlide])
                .find(".clp-section9__player")
                .attr("id");

            if (!players[player]) return;
            players[player].stopVideo();
        }
    );

    handsOnSlider.on(
        "afterChange",
        function (event, slick, currentSlide, nextSlide) {
            jQuery(".clp-section9__v-wrapper").removeClass("no-click");
        }
    );

    addRemoveSliders();
    jQuery(window).on("resize", function () {
        addRemoveSliders();
    });

    function addRemoveSliders() {
        var width = jQuery(window).outerWidth();

        // if (width <= 1200) {
        //     jQuery(".clp-section10__slider").not('.slick-initialized').slick({
        //         centerMode: true,
        //         arrows: false,
        //         variableWidth: true,
        //         dots: true,
        //         responsive: [
        //             {
        //                 breakpoint: 650,
        //                 settings: {
        //                     centerMode: false,
        //                     variableWidth: false,
        //                     adaptiveHeight: true
        //                 }
        //             }
        //         ]
        //     });
        // } else {
        //     jQuery(".clp-section10__slider.slick-initialized").slick("unslick");
        // }

        if (width <= 1100) {
            // 'what you learn' slider
            jQuery(".clp-section1__learn-list")
                .not(".slick-initialized")
                .slick({
                    centerMode: true,
                    arrows: false,
                    variableWidth: true,
                    dots: true,
                    autoplay: true,
                    responsive: [
                        {
                            breakpoint: 650,
                            settings: {
                                centerMode: false,
                                variableWidth: false,
                            },
                        },
                    ],
                });
        } else {
            jQuery(".clp-section1__learn-list.slick-initialized").slick("unslick");
        }
    }

    //Testimonials slider
    jQuery(".clp-section15__slider").slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        autoplay: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    adaptiveHeight: true,
                },
            },
        ],
    });

    // the giveaway page
    jQuery(".giveaway-page .clp-btn-black, .giveaway-page .clp-btn-pink").on(
        "click",
        function (e) {
            e.preventDefault();
            jQuery(".giveaway-page .clp-popup").addClass("active");
            jQuery("body").addClass("clp-body-open");
        }
    );

    jQuery(".clp-popup__close").on("click", function () {
        jQuery(this).parent().removeClass("active");
        jQuery("body").removeClass("clp-body-open");
    });

    function handleInputs() {
        let inputs = document.querySelectorAll(
            ".giveaway-page .clp-input input"
        );

        inputs.forEach((input) => {
            if (input.value)
                input.parentElement.classList.add("clp-input_active");
            else input.parentElement.classList.remove("clp-input_active");

            input.addEventListener("blur", function () {
                if (this.value)
                    this.parentElement.classList.add("clp-input_active");
                else this.parentElement.classList.remove("clp-input_active");
            });

            input.addEventListener("focus", function () {
                this.parentElement.classList.remove("clp-input_err");
            });
        });
    }

    handleInputs();

    if (jQuery("#clp-state")[0]) jQuery("#clp-state").niceSelect();

    // reviews page header
    function handleReviewsHeader() {
        var reviews = jQuery(".sm-reviews__reviews .yotpo");
        var reviewsText = reviews.find(".text-m").text();

        if (!reviewsText) {
            setTimeout(() => {
                handleReviewsHeader();
            }, 100);
        } else {
            var headerReviews = jQuery(".sm-reviews__header .yotpo");
            headerReviews.find(".text-m").html(reviewsText);
            headerReviews.on("click", function () {
                jQuery([document.documentElement, document.body]).animate(
                    {
                        scrollTop: reviews.offset().top,
                    },
                    1000
                );
            });
        }
    }
    handleReviewsHeader();

    function createStylistSlider(galleries) {
        galleries.hide();
        galleries.eq(0).show();

        const slider = jQuery(".stylist-sliders__stylists");
        slider.slick({
            slidesToShow: 6,
            prevArrow: '<span class="clp-arrow clp-arrow_prev"></span>',
            nextArrow: '<span class="clp-arrow clp-arrow_next"></span>',
            responsive: [
                {
                    breakpoint: 650,
                    settings: {
                        slidesToShow: 4,
                    },
                },
            ],
        });

        jQuery(".stylist-sliders__stylist").click(function (e) {
            e.preventDefault();
            var slide = jQuery(this).data("slide");
            slider.slick("slickGoTo", slide - 1);
        });

        slider.on(
            "afterChange",
            function (event, slick, currentSlide, nextSlide) {
                galleries.hide();
                galleries.eq(currentSlide).show();
                teamSlider.slick("slickGoTo", currentSlide);
                gallerySliders[currentSlide].slick("refresh");
            }
        );
    }

    let gallerySliders = [];

    function createGallerySliders() {
        galleries.each((index, gallery) => {
            let slider = jQuery(gallery).slick({
                slidesToShow: 2,
                slidesToScroll: 2,
                prevArrow: '<span class="clp-arrow clp-arrow_prev"></span>',
                nextArrow: '<span class="clp-arrow clp-arrow_next"></span>',
                dots: true,
                responsive: [
                    {
                        breakpoint: 650,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            });

            gallerySliders.push(slider);
        });
    }

    function createTeamMembersSlider() {
        teamSlider = jQuery(".stylist-sliders__team-members").slick({
            arrows: false,
            dots: false,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: "linear",
            asNavFor: ".stylist-sliders__stylists",
        });
    }

    function logoSlider() {
        jQuery(".join-up__scroller ul").slick({
            speed: 3000,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: "linear",
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: true,
            centerMode: true,
            arrows: false,
            variableWidth: true,
        });
    }

    const galleries = jQuery(".stylist-sliders__gallery");
    let teamSlider;

    jQuery(".clp-section3__list-wrapper").mCustomScrollbar();

    createGallerySliders(galleries);
    createStylistSlider(galleries);
    createTeamMembersSlider();
    logoSlider();
});
